import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { QRCodeModule } from "angularx-qrcode";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";

@Component({
  selector: "app-generic-qr-scan-dialog",
  templateUrl: "./generic-qr-scan-dialog.component.html",
  styleUrls: ["./generic-qr-scan-dialog.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatDividerModule,
    QRCodeModule,
    ZXingScannerModule,
  ]
})
export class GenericQrScanDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GenericQrScanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
    }
  }

  scanSuccessHandler(data: string) {
    this.close(data);
  }

  close(result: string) {
    this.dialogRef.close(result);
  }
}
